import { render, staticRenderFns } from "./SurfaceHeader.vue?vue&type=template&id=9518a890&"
import script from "./SurfaceHeader.vue?vue&type=script&lang=ts&"
export * from "./SurfaceHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports